module.exports = "/static/js/d9dc62a517f333a3c0ecd84b2fc9048d.png";